module.exports = __webpack_public_path__ + "static/media/putri_brand_banner.f5273ccc.jpg";